import { Stack } from "@mui/material";
import { getOrdinalPostfix } from "@src/appV2/lib/utils/formatNumbers";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

import { isScoreHealthy } from "../utils/utils";

interface RankingLabelProps {
  rank: number;
  outOf: number;
  qualification: string;
}

interface RankingLabelWithIconProps extends RankingLabelProps {
  score: number;
}

export function RankingLabel(props: RankingLabelProps) {
  const { rank, outOf, qualification } = props;

  return (
    <Text>
      {rank}
      {getOrdinalPostfix(rank)} /{" "}
      <Text inline color={(theme) => theme.palette.grey[600]}>
        {outOf}
      </Text>{" "}
      local {qualification}s
    </Text>
  );
}

export function RankingLabelWithIcon(props: RankingLabelWithIconProps) {
  const { score, rank, outOf, qualification } = props;

  return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={3}>
      <CbhIcon
        type={
          isScoreHealthy(score)
            ? "clipboard-score-healthy-colored"
            : "clipboard-score-unhealthy-colored"
        }
        size="small"
      />
      <RankingLabel rank={rank} outOf={outOf} qualification={qualification} />
    </Stack>
  );
}
